'use strict';

import GraphQL from '../../services/graphql';

const databaseSearch = {
  namespaced: true,

  state: {
    endpoint: '/graphql',
    searching: false,
    results: [],
    errorMessage: "",

    // Pagination
    totalCount: 0,
    pageSize: 20,
    hasNextPage: false,
    cursor: '',

    // Primary facets
    query: '',
    recordType: '',

    // Person facets
    races: [],
    genders: [],
    partyAffiliations: [],

    // Election facets
    electionYear: '',

    // District facets
    prosecutorsAre: ''
  },
  mutations: {
    setResults(state, array) {
      state.results = array;
    },
    addResults (state, array) {
      state.results = state.results.concat(array);
    },
    setTotalCount(state, integer) {
      state.totalCount = integer;
    },
    clearResults (state) {
      state.errorMessage = "";
      state.results = [];
      state.cursor = '';
      state.totalCount = 0;
      state.hasNextPage = false;
    },
    startSearching (state) {
      state.searching = true;
    },
    stopSearching (state) {
      state.searching = false;
    },
    setHasNextPage (state, boolean) {
      state.hasNextPage = boolean;
    },
    setCursor (state, string) {
      state.cursor = string;
    },
    resetCursor (state) {
      state.cursor = '';
    },

    // Primary facet mutations
    setQuery (state, string) {
      state.query = string;
    },

    setRecordType(state, string) {
      state.recordType = string;
    },

    // People facet Mutations
    setGenders (state, array) {
      state.genders = array;
    },

    setRaces (state, array) {
      state.races = array;
    },

    setPartyAffiliations (state, array) {
      state.partyAffiliations = array;
    },

    clearPersonFacets (state) {
      state.races = [];
      state.genders = [];
      state.partyAffiliations = [];
    },

    clearDistrictFactes (state) {
      state.prosecutorsAre = '';
    },

    // Elections facet Mutations
    setElectionYear (state, integer) {
      state.electionYear = integer;
    },

    setProsecutorsAre (state, string) {
      state.prosecutorsAre = string;
    },

    clearElectionFacets (state) {
      state.electionYear = '';
    },

    setErrorMessage (state, string) {
      state.errorMessage = string;
    }
  },

  actions: {
    getResults ({commit, state, dispatch, getters}) {
      commit('startSearching');
      commit('setErrorMessage', '');
      commit('resetCursor');
      GraphQL.post(getters.graphql)
        // Success
        .then( response => {
          let search = response.data.search;
          let results = search.edges;
          commit('setResults', results);
          if ( results.length > 0 ) {
            commit('setTotalCount', search.totalCount);
            commit('setCursor', results[results.length-1].cursor);
          }
          commit('setHasNextPage', search.pageInfo.hasNextPage);
          commit('stopSearching');
        })
        // Failure
        .catch( () => {
          commit('setErrorMessage', 'Something went wrong, your search could not be completed. Please <a href="/search">Try Again</a>.');
          commit('stopSearching');
        });
    },

    getNextResults ({commit, state, dispatch, getters}) {
      commit('startSearching');
      GraphQL.post(getters.graphql)
        // Success
        .then( response => {
          let search = response.data.search;
          let results = search.edges;
          commit('addResults', results);
          commit('setCursor', results[results.length-1].cursor);
          commit('setHasNextPage', search.pageInfo.hasNextPage);
          commit('stopSearching');
        });
    }
  },

  getters: {
    params (state) {
      let params = {};
      if (!!state.query) {
        params.query = state.query;
      }
      if (!!state.recordType) {
        params.recordType = state.recordType;
      }
      if (state.races.length > 0) {
        params.races = state.races;
      }
      if (state.genders.length > 0) {
        params.genders = state.genders;
      }
      if (state.partyAffiliations.length > 0) {
        params.partyAffiliations = state.partyAffiliations;
      }
      if (!!state.electionYear) {
        params.electionYear = state.electionYear;
      }
      if (!!state.prosecutorsAre) {
        params.prosecutorsAre = state.prosecutorsAre;
      }
      return params;
    },

    graphqlArgs (state) {
      let args = [];
      if (!!state.query) {
        args.unshift(`query:"${state.query}"`);
      }
      if (!!state.recordType) {
        args.unshift(`recordType:"${state.recordType}"`);
      }
      if (state.races.length > 0) {
        args.unshift(`races:${JSON.stringify(state.races)}`);
      }
      if (state.genders.length > 0) {
        args.unshift(`genders:${JSON.stringify(state.genders)}`);
      }
      if (state.partyAffiliations.length > 0) {
        args.unshift(`partyAffiliations:${JSON.stringify(state.partyAffiliations)}`);
      }
      if (!!state.electionYear) {
        args.unshift(`electionYear:${parseInt(state.electionYear)}`);
      }
      if (!!state.prosecutorsAre) {
        args.unshift(`prosecutorsAre:"${state.prosecutorsAre}"`);
      }
      args.unshift(`first:${state.pageSize}`);
      args.unshift(`after:"${state.cursor}"`);
      return args.join(', ');
    },

    graphql (state, getters) {
      return `{
        search(${getters.graphqlArgs}) {
          totalCount
          pageInfo {
            hasNextPage
          }
          edges {
            node {
              ... on District {
                type
                id
                name
                state_name
                path
              }
              ... on Person {
                type
                id
                full_name
                party_name
                path
              }
              ... on Election {
                type
                id
                year
                name
                district_name
                state_name
                path
              }
            }
            cursor
          }
        }
      }`;
    }
  }
}

export default databaseSearch;



// WEBPACK FOOTER //
// ./app/javascript/vue/vuex/modules/database-search.js